import React from "react";
import {
    FaTwitter,
    FaGithub,
    FaLinkedin,
    FaFacebook,
    FaInstagram,
    FaYoutube,
    FaDiscord,
    FaPinterest,
    FaTiktok,
    FaReddit,
} from "react-icons/fa";

const socialMediaIcons = {
    x: FaTwitter,
    github: FaGithub,
    linkedin: FaLinkedin,
    facebook: FaFacebook,
    instagram: FaInstagram,
    youtube: FaYoutube,
    discord: FaDiscord,
    pinterest: FaPinterest,
    tiktok: FaTiktok,
    reddit: FaReddit,
};

export const SocialMediaLinks = ({ socialMediaUrls }) => {
    if (!socialMediaUrls || Object.keys(socialMediaUrls).length === 0) {
        return null;
    }

    return (
        <div className="flex items-center gap-4">
            {Object.entries(socialMediaUrls).map(([platform, url]) => {
                const Icon = socialMediaIcons[platform];
                if (!Icon || !url || url.trim() === "") return null;

                return (
                    <a
                        key={platform}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group relative flex items-center justify-center w-8 h-8 rounded-lg bg-blue-50 text-blue-600 transition-all duration-300 ease-in-out hover:bg-blue-100 hover:text-blue-700 hover:shadow-md hover:-translate-y-0.5"
                        aria-label={`Visit our ${platform} page`}
                    >
                        <Icon className="w-4 h-4 transition-transform duration-300 group-hover:scale-110" />
                        <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 px-2 py-1 text-xs font-medium text-white bg-blue-900 rounded opacity-0 transition-opacity duration-200 group-hover:opacity-100 whitespace-nowrap">
                            {url.replace(/^https?:\/\//, "").replace(/\/$/, "")}
                        </span>
                    </a>
                );
            })}
        </div>
    );
};
